import {IntermediatePart} from "../../intermediatePart";

export default class CenterWall extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'center_wall';
    this.partName = 'Center Wall';
    this.translateId = "visualizer.bathroom.walls.center_wall";
    this.activeFeatureBeforeAllWalls = null;
    this.allWallsApplied = true;
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new CenterWall());
  }
}
